<!-- Header Section Start -->
<div class="content-container" (click)="clickEvent()">

  <section id="neet-top-pannel">
    <div class="neet-wrapper">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-4 text-center m-hide rht-img">
          <figure>
            <img src="assets/img/girl-yellow.png" alt="" class="img-fluid">
          </figure>
        </div>
        <div class="col-12 col-md-12 col-lg-8 dddddd">
          <div class="rht-content">
            <div class="m-hide-570">
              <div class="neet-main-title">
                <h1>Cracking NEET</h1>
                <p>is not a Dream Anymore</p>
              </div>
              <!-- <h1>NEET 2021</h1>
              <p>Boost your rank with us</p> -->
              <h6>LIVE Classes | Test Series | Mock Tests | Previous Year Papers</h6>
              <!-- <div class="bordered"> -->
              <button (click)="openTestSeriesSchedule()" type="button"
                class="btn btn-danger view-test-btn test-color"><a class="test-schedule">View test series
                  schedule</a></button>
            </div>
            <!-- </div> -->
            <h5>Start learning for FREE Now</h5>
            <div class="t-center m-show-570">
              <span id="neet-heading">Cracking NEET <br>
                <p>is not a Dream Anymore</p>
              </span>
            </div>
            <div class="m-show img-container">
              <figure>
                <img src="assets/img/girl-yellow.png" alt="" class="img-fluid">
              </figure>

              <div [class.srichaitanya-tenant]="tenant=='srichaitanya'" class="form-wrapper">
                <ng-container *ngIf="tenant=='srichaitanya';else notSrichaitanyaFormMobile">
                  <div class="form-group">
                    <form [formGroup]="sriChaitanyaStartForm" class="common-intl-phone-form">
                      <input [maxlength]="SCMaxLength" formControlName="admissionNumber" [placeholder]="SCPlaceHolder"
                        class="form-control common-intl-phone">
                      <button (click)="openAdmissionLoginForm(sriChaitanyaStartForm.value)"
                        [disabled]="!customSriChaitanyaStartFormValid || !sriChaitanyaStartForm.valid " type="button"
                        class="btn btn-primary btn-danger">START LEARNING</button>
                    </form>
                  </div>
                </ng-container>
                <ng-template #notSrichaitanyaFormMobile>
                  <!-- {{tenant}} -->
                  <form method="POST">
                    <app-common-mobile-number class="assessments-common-mobile-number"
                      (mobileNumberChange)="doSearch($event)" (callSignUp)="signup('neet', searchValue)">
                    </app-common-mobile-number>
                  </form>
                </ng-template>
                <div class="d-flex justify-content-center IL_sc-click white font-weight-bold assessment_mt-10">
                    <span *ngIf="tenant == 'srichaitanya';else others">Forgot Password? - <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">Click Here</span></span>
                    <ng-template #others>
                      <span>Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
                    </ng-template>  
                </div>
              </div>
              
            </div>
            <div id="insp" class="m-show-570">
              Take <span class="hlt">Competitive exam preparation<br /></span> to the next level
              <button (click)="openTestSeriesSchedule()" type="button" class="btn btn-danger view-test-btn">View test
                series schedule</button>
            </div>

            <div [class.srichaitanya-tenant]="tenant=='srichaitanya'" class="m-hide form-wrapper">
              <ng-container *ngIf="tenant=='srichaitanya';else notSrichaitanyaForm">
                <div class="form-group">
                  <form [formGroup]="sriChaitanyaStartForm" class="common-intl-phone-form">
                    <input [maxlength]="SCMaxLength" formControlName="admissionNumber" [placeholder]="SCPlaceHolder"
                      class="form-control common-intl-phone">
                    <button (click)="openAdmissionLoginForm(sriChaitanyaStartForm.value)"
                      [disabled]="!customSriChaitanyaStartFormValid || !sriChaitanyaStartForm.valid " type="button"
                      class="btn btn-primary btn-danger">START LEARNING</button>
                  </form>
                </div>
              </ng-container>
              <ng-template #notSrichaitanyaForm>
                <form method="POST">
                  <app-common-mobile-number class="assessments-common-mobile-number"
                    (mobileNumberChange)="doSearch($event)" (callSignUp)="signup('neet', searchValue)">
                  </app-common-mobile-number>
                </form>
              </ng-template>
              <div class="d-flex justify-content-center IL_sc-click white font-weight-bold assessment_mt-10">
                <span *ngIf="tenant == 'srichaitanya';else others">Forgot Password? - <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">Click Here</span></span>
                <ng-template #others>
                  <span>Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
                </ng-template>  
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Header Section End -->

  <!-- NEET cources section start -->
  <section id="neet-courses-pannel">
    <div class="ncp-inner">
      <div class="row">
        <!-- <div class="col-12 col-md-4 mb-55">
          <div class="neet-course-box" id="neet-course-box-1">
            <figure>
              <img src="assets/img/top-educators.svg" alt="">
            </figure>
            <h4>Classes with India's top educators</h4>
            <p>Expert educators, specializing in their area of expertise support our learners</p>
          </div>
        </div>
        <div class="col-12 col-md-4 mb-55">
          <div class="neet-course-box" id="neet-course-box-2">
            <figure>
              <img src="assets/img/engaging-interactive-classes.svg" alt="">
            </figure>
            <h4>Engaging and interactive classes</h4>
            <p>Learning is made easy with our interactive portal. Try It for yourself!</p>
          </div>
        </div>
        <div class="col-12 col-md-4 mb-55">
          <div class="neet-course-box" id="neet-course-box-3">
            <figure>
              <img src="assets/img/ilts-icon.svg" alt="">
              
              <button (click)="openTestSeriesSchedule()"
                         type="button"
                        class="btn btn-danger view-test-btn"><a class="test-schedule test-schedule-ilts">View Schedule</a></button>
            </figure>
            
            <h4>Infinity Learn Test Series (ILTS)</h4>
            <p>Assess where you stand compared to others by taking synchronised tests with students across the world to
              improve your rank.</p>
          </div> 
        </div> -->

        <div class="col-12 col-lg-6 col-md-12 col-sm-12 mt-100">
          <div class="feature-box">
            <div class="feature-icon">
              <img src="assets/img/ineet-one.png" alt="">
              <div class="feature-text">
                <h4>FREE Live Classes</h4>
              </div>
            </div>
            <p>Expert faculties to help you get top ranks in NEET. Register for your free session,
              Attend Live sessions, quizzes to help you beat the competition or <span><a routerLink='/neet-liveclasses'
                  class="explore-text">explore more</a></span></p>
            <div class="feature-clsbtn">
              <p>Live classes | Strategies | Tips & Tricks </p>
              <!-- <div class="reg-for-btn">
                <a (click)="openNeetLiveClassDialog('lc')"><button type="button" class="reg-btn">START FOR
                    FREE</button></a>
              </div> -->
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-6 col-md-12 mt-100">
          <div class="feature-box">
            <div class="feature-icon">
              <img src="assets/img/ineet-two.png" alt="">
              <div class="feature-text">
                <h4>TEST SERIES</h4>
              </div>
            </div>
            <p>Assess where you stand compared to others by taking synchronized tests with students across
              the nation and improve your rank. Register for free or <span><a routerLink='/testseries'
                  class="explore-text">explore more</a></span></p>
            <div class="feature-clsbtn">
              <p>All subject covered | Scheduled Tests</p>
              <!-- <div class="reg-for-btn">
                <a (click)="openNeetLiveClassDialog('ts')"><button type="button" class="reg-btn">START FOR
                    FREE</button></a>
              </div> -->
            </div>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-12 col-lg-6 col-md-12 mt-100 mb-100">
          <div class="feature-box">
            <div class="feature-icon">
              <img src="assets/img/ineet-three.png" alt="">
              <div class="feature-text">
                <h4>Mock Tests (MCT's)</h4>
              </div>
            </div>
            <p>Take mock tests with simulated test environment to improve your speed and accuracy.</p>
          </div>
        </div>

        <div class="col-12 col-lg-6 col-md-12 mt-100 mb-100">
          <div class="feature-box">
            <div class="feature-icon">
              <img src="assets/img/ineet-four.png" alt="">
              <div class="feature-text">
                <h4>Previous Year Papers (PYP's)</h4>
              </div>
            </div>
            <p>Revise and practice with previous year papers to stay on top of the latest pattern and trends of
              questions.</p>
          </div>
        </div>


        <!-- <div class="col-12 col-md-4 mb-55">
          <div class="neet-course-box" id="neet-course-box-4">
            <figure>
              <img src="assets/img/mtct-icon.svg" alt="">
            </figure>
            <h4>Mock Tests <br> (MCT's)</h4>
            <p>Take mock tests with simulated test environment to improve your speed and accuracy.</p>
          </div>
        </div>
        <div class="col-12 col-md-4 mb-55">
          <div class="neet-course-box" id="neet-course-box-5">
            <figure>
              <img src="assets/img/pyp-icon.svg" alt="">
            </figure>
            <h4>Previous Year Papers <br>(PYP's)</h4>
            <p>Revise and practice with previous year papers to stay on top of the latest pattern and trends of questions.
            </p>
          </div>
        </div>
        <div class="col-12 col-md-4 mb-55">
          <div class="neet-course-box" id="neet-course-box-6">
            <figure>
              <img src="assets/img/Result-Oriented-curriculum-icon.svg" alt="">
            </figure>
            <h4>Result-Oriented curriculum</h4>
            <p>Steer yourself towards smart learning to improve your performance.</p>
          </div>
        </div> -->
      </div>

      <!-- <div id="live-class-box-wrapper">
        <div class="row">
          <div class="col-12">
            <div class="live-class-box">
              <div class="text">
                <h6>NEET Live Classes</h6>
                <p>Live classes with India's top educators for preparation of NEET.</p>
              </div>
              <div class="btn-area">
                <button type="button" class="btn btn-primary btn-register"
                  (click)="openNeetLiveClassDialog('')">REGISTER</button>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </section>
  <!-- NEET cources section End -->



  <!-- Footer Start -->
  <app-footer></app-footer>
  <!-- Footer End -->
</div>